import CryptoJS from 'crypto-js'

//加密
var keyvi = '0p9o8i7u';
function des_encrypt(pwd) {
    var key            = CryptoJS.MD5(keyvi).toString();
    var iv            = CryptoJS.MD5(keyvi).toString();
    var crypto_key     = CryptoJS.enc.Utf8.parse(key);
    var crypto_iv     = CryptoJS.enc.Utf8.parse(iv.substr(0,8));

    var encode_str     = CryptoJS.TripleDES.encrypt(pwd, crypto_key, {
                        iv:         crypto_iv,
                        mode:         CryptoJS.mode.CBC,
                        padding:     CryptoJS.pad.Pkcs7});
    return encode_str.toString();

}
//解密
function des_decrypt(pwd)
{
    var key            = CryptoJS.MD5(keyvi).toString();
    var iv            = CryptoJS.MD5(keyvi).toString();
    var crypto_key     = CryptoJS.enc.Utf8.parse(key);
    var crypto_iv     = CryptoJS.enc.Utf8.parse(iv.substr(0,8));
    var decrypt_str    = CryptoJS.TripleDES.decrypt(pwd, crypto_key, {
                        iv:         crypto_iv,
                        mode:         CryptoJS.mode.CBC,
                        padding:     CryptoJS.pad.Pkcs7});
    return     decrypt_str.toString(CryptoJS.enc.Utf8);
}

export default {
    des_encrypt,
    des_decrypt
}



// WEBPACK FOOTER //
// ./src/service/des.js